import { defineStore } from 'pinia'
import type { IUserData } from '@/stores/types'
import { COOKIE_OPTIONS } from '@/utils/constants/cookies'
import { syncSAPContact, unlinkSAPContact } from '@/utils/sap'

const DEFAULT_USER_DATA = {
  firstName: '',
  lastName: '',
  email: '',
  clean: false
}

export const useUserStore = defineStore('user', () => {
  const runtimeConfig = useRuntimeConfig()
  const isUserLogged = ref(false)
  const userData = ref<IUserData>({ ...DEFAULT_USER_DATA })
  const authCookie = useCookie(runtimeConfig.public.authCookieName, COOKIE_OPTIONS)

  function setUserData(data: IUserData) {
    if (!data) return

    userData.value = {
      ...data,
      initials: `${data.firstName?.charAt(0)}${data.lastName?.charAt(0)}`
    }
    isUserLogged.value = true
    syncSAPContactWithSession()
  }

  function logOutUser() {
    userData.value = { ...DEFAULT_USER_DATA }
    authCookie.value = null
    isUserLogged.value = false
    syncSAPContactWithSession()
  }

  function syncSAPContactWithSession(): Promise<boolean> {
    const pinsNumber = userData.value.pinsNumber

    return isUserLogged.value && pinsNumber ? syncSAPContact(pinsNumber) : unlinkSAPContact()
  }

  return {
    isUserLogged,
    userData,
    setUserData,
    logOutUser,
    syncSAPContact: syncSAPContactWithSession
  }
})
